/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc
 */
import * as References from './StandardizedInstallTypeRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc#getStandardizedInstallType
 */
export const GET_STANDARDIZED_INSTALL_TYPE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallTypeRpc_getStandardizedInstallType';
export const GET_STANDARDIZED_INSTALL_TYPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_STANDARDIZED_INSTALL_TYPE_QUERY_FIELD_NAME,
  args: ['listingId', 'published'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getStandardizedInstallTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc#updateStandardizedInstallTypeForDraftListing
 */
export const UPDATE_STANDARDIZED_INSTALL_TYPE_FOR_DRAFT_LISTING_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_listing_details_rpc_StandardizedInstallTypeRpc_updateStandardizedInstallTypeForDraftListing';
export const UPDATE_STANDARDIZED_INSTALL_TYPE_FOR_DRAFT_LISTING_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_STANDARDIZED_INSTALL_TYPE_FOR_DRAFT_LISTING_MUTATION_FIELD_NAME,
  args: ['listingId', 'installType', 'callerPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.updateStandardizedInstallTypeForDraftListingRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});